import Vue from 'vue';
import { ADD_TOAST_MESSAGE } from "vuex-toast";

const types = {
  LOADING: 'LOADING',
  LOAD_FORM: 'LOAD_FORM',
  SUCCESS: 'SUCCESS',
  FAIL: 'FAIL',
  SET_FIELD: 'SET_FIELD',
};

// initial state
const initalState = {
  form: {},
  error: null,
  loading: false,
};

// getters
const getters = {
  form: state => state.form,
  loading: state => state.loading,
  error: state => state.error,
};

// actions
const actions = {
  setField({ commit }, { key, value }) {
    commit(types.SET_FIELD, { key, value });
  },
};

// mutations
const mutations = {
  [types.SET_FIELD](state, params) {
    Vue.set(state.form, params.key, params.value);
  },

  [types.LOADING](state, loading) {
    state.loading = loading;
  },

  [types.LOAD_FORM](state, data) {
    Vue.set(state, 'form', data);
    Vue.set(state, 'loading', false);
  },

  [types.SUCCESS](state) {
    state.loading = false;
  },

  [types.FAIL](state) {
    state.loading = false;
  },
};

export default {
  namespaced: true,
  state: initalState,
  getters,
  actions,
  mutations,
};
